import React, { useState, useMemo, useCallback, useEffect } from "react";
import Card from "react-bootstrap/Card";
import Form from "react-bootstrap/Form";
import { FaChevronDown } from "react-icons/fa";
import SimpleTable from "../../../components/atoms/table/simpleTable/simpleTable";
import Button from "../../../components/atoms/button/Button";
import ReusableModal from "../../../components/atoms/modal/ReusableModal";
import DateRangePicker from "../../../components/atoms/daterangePicker/DateRangePicker";
import Spinner from "react-bootstrap/Spinner";
import "../../../styles/typography.css";
import "./RequestedList.css";
import {
  getRequestedListData,
  getStatusData,
  // getStatesData,
  getSpeciesData,
  getPrintSampleData,
  getProductTypeData,
  getSampleEditData,
  updateSampleEditData,
  updateLocation,
  getLocationsByCompanyId,
  getUnitsData,
} from "./requestedListApi";
import { formatDate } from "../../../utility/Formatdate";
import "../../../styles/typography.css";
import SampleEditPage from "./SampleEditPage";
import SecondTab from "../../../components/organisms/secondTab";
import { LabAdminTabConfig } from "../LabAdmin.constants";
import { Tab } from "react-bootstrap";
import Dropdown from "react-bootstrap/Dropdown";
import { toast, ToastContainer } from "react-toastify";
import SampleModalWrapper from "../../../components/organisms/SampleModalWrapper/SampleModalWrapper";
import { markSampleAsRejectedWithReason } from "../ScanSample/scanSampleApi";
import PageDescriptionBar from "../../../components/atoms/pageDescriptionBar/PageDescriptionBar";

const initialAdvancedSearch = {
  groupId: "",
  companyName: "",
  userName: "",
  salesRep: "",
  customerSampleId: "",
  lotNumber: "",
  sampleId: "",
  productType: "All",
  speciesType: "All",
  // state: "All",
};

const RequestedList = ({ TabConfig }) => {
  const today = new Date();
  const oneMonthAgo = new Date();
  oneMonthAgo.setMonth(today.getMonth() - 1);

  // Filters
  const [fromDate, setFromDate] = useState(oneMonthAgo);
  const [toDate, setToDate] = useState(today);
  const [paginationData, setPaginationData] = useState({});

  // Table
  const [expandedId, setExpandedId] = useState([]);
  const [selectedRowIds, setSelectedRowIds] = useState(new Set());
  const [selectedSampleIds, setSelectedSampleIds] = useState(new Set());

  // Advanced search modal
  const [showAdvancedSearch, setShowAdvancedSearch] = useState(false);
  const [requestedListData, setRequestedListData] = useState([]);

  // Edit modal
  const [showEditModal, setShowEditModal] = useState(false);
  const [editRowData, setEditRowData] = useState(null);

  // Status options for the dropdown
  const [statusOptions, setStatusOptions] = useState(["All"]);
  // const [stateOptions, setStateOptions] = useState(["All"]); // <-- add state options
  const [speciesOptions, setSpeciesOptions] = useState([
    { value: "All", label: "All" },
  ]); // <-- add species options
  const [productTypeOptions, setProductTypeOptions] = useState([
    { value: "All", label: "All" },
  ]);
  const [unitsOptions, setUnitsOptions] = useState([
    { value: "All", label: "All" },
  ]);
  const [expandAll, setExpandAll] = useState(false);

  const toggleExpandAll = () => {
    if (!expandAll) {
      setExpandedId(requestedListData.map((item) => item.groupID));
    } else {
      setExpandedId([]);
    }
    setExpandAll((prev) => !prev);
  };
  // Add this state at the top of your component
  const [advancedSearch, setAdvancedSearch] = useState(initialAdvancedSearch);
  const [showEditGroupModal, setShowEditGroupModal] = useState(false);
  const [editGroupRow, setEditGroupRow] = useState(null);
  const [newLocationId, setNewLocationId] = useState("");
  const [locationOptions, setLocationOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedStatuses, setSelectedStatuses] = useState([]);
  const [useAdvancedDates, setUseAdvancedDates] = useState(false);
  const [sample, setSample] = useState(null);
  const [showMainRejectConfirm, setShowMainRejectConfirm] = useState(false); // Main table reject
  const [removeReason, setRemoveReason] = useState("");
  const isLabAdmin = useMemo(() => {
    try {
      return JSON.parse(localStorage.getItem("currentRole")) === "Lab Admin";
    } catch {
      return false;
    }
  }, []);

  // Fetch locations for Edit Group modal when modal opens
  useEffect(() => {
    const fetchLocations = async () => {
      if (showEditGroupModal && editGroupRow?.companyID) {
        try {
          const res = await getLocationsByCompanyId(editGroupRow.companyID);
          setLocationOptions(Array.isArray(res) ? res : []);
        } catch {
          setLocationOptions([]);
        }
      }
    };
    fetchLocations();
  }, [showEditGroupModal, editGroupRow]);

  useEffect(() => {
    setUseAdvancedDates(false);
    fetchData("", 1, 25, { useDateFilters: false });
  }, [selectedStatuses]);

  useEffect(() => {
    // Fetch status options for the dropdown
    const fetchStatusOptions = async () => {
      try {
        const res = await getStatusData();
        if (Array.isArray(res) && res.length > 0) {
          setStatusOptions([...res]);
        }
      } catch {
        setStatusOptions([]);
      }
    };
    fetchStatusOptions();
  }, []);

  // useEffect(() => {
  //   const fetchStateOptions = async () => {
  //     try {
  //       const res = await getStatesData();
  //       if (Array.isArray(res) && res.length > 0) {
  //         setStateOptions(["All", ...res.map((s) => s.stateName)]);
  //       }
  //     } catch {
  //       setStateOptions(["All"]);
  //     }
  //   };
  //   fetchStateOptions();
  // }, []);

  useEffect(() => {
    const fetchUnitsOptions = async () => {
      try {
        const res = await getUnitsData();
        if (Array.isArray(res) && res.length > 0) {
          setUnitsOptions([
            { value: "All", label: "All" },
            ...res.map((s) => ({ value: s.unitId, label: s.name })),
          ]);
        }
      } catch {
        setUnitsOptions([{ value: "All", label: "All" }]);
      }
    };
    fetchUnitsOptions();
  }, []);

  useEffect(() => {
    // Fetch species options for the advanced search dropdown
    const fetchSpeciesOptions = async () => {
      try {
        const res = await getSpeciesData();
        if (Array.isArray(res) && res.length > 0) {
          setSpeciesOptions([
            { value: "All", label: "All" },
            ...res.map((s) => ({ value: s.speciesId, label: s.name })),
          ]);
        }
      } catch {
        setSpeciesOptions([{ value: "All", label: "All" }]);
      }
    };
    fetchSpeciesOptions();
  }, []);

  useEffect(() => {
    // Fetch product options for the advanced search dropdown
    const fetchProductTypeOptions = async () => {
      try {
        const res = await getProductTypeData();
        if (Array.isArray(res) && res.length > 0) {
          setProductTypeOptions([
            { value: "All", label: "All" },
            ...res.map((p) => ({ value: p.productTypeId, label: p.name })),
          ]);
        }
      } catch {
        setProductTypeOptions([{ value: "All", label: "All" }]);
      }
    };
    fetchProductTypeOptions();
  }, []);

  const handleEditGroupClick = async (row) => {
    setEditGroupRow(row);
    setShowEditGroupModal(true);
    if (row.companyID) {
      try {
        const locations = await getLocationsByCompanyId(row.companyID);

        setLocationOptions(Array.isArray(locations) ? locations : []);
      } catch {
        setLocationOptions([]);
      }
    } else {
      setLocationOptions([]);
    }
  };

  // Update handler for all inputs
  const handleAdvancedInputChange = (e) => {
    const { name, value } = e.target;
    setAdvancedSearch((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const getNonRejectedSelectedSampleIds = useCallback(() => {
    const eligibleSampleIds = [];

    for (const group of requestedListData || []) {
      const samples = Array.isArray(group.requestedSamples)
        ? group.requestedSamples
        : [];

      for (const sampleRow of samples) {
        if (!selectedSampleIds.has(sampleRow.sampleId)) continue;

        const statusText = String(sampleRow.lastStatus || "").toLowerCase();
        if (!statusText.includes("reject")) {
          eligibleSampleIds.push(sampleRow.sampleId);
        }
      }
    }

    return eligibleSampleIds;
  }, [requestedListData, selectedSampleIds]);
  
  // Update handler for all inputs
  const handleRemoveSamples = () => {
    const sampleIdsArray = getNonRejectedSelectedSampleIds();
    
    if(sampleIdsArray.length===0){
      toast.warning("Please select at least one non-rejected sample to remove");
      return;
    }
    setRemoveReason("");
    setShowMainRejectConfirm(true);
    console.log("",sampleIdsArray);
  };


  const handleConfirmReject = async () => {
      try {
        if (!removeReason.trim()) {
          toast.warning("Please enter a reason to remove selected samples");
          return;
        }

        const sampleIdsArray = getNonRejectedSelectedSampleIds();
        if (sampleIdsArray.length === 0) {
          toast.warning("No eligible non-rejected samples selected for remove");
          setShowMainRejectConfirm(false);
          return;
        }
        
        const result =await markSampleAsRejectedWithReason(sampleIdsArray, removeReason.trim());
        console.log("Reject result:", result);

        if (result === 'success') {
          toast.success("Selected samples have been remove successfully");
        }
        else {
          toast.error("Failed to remove selected samples. Please try again.");
        }

      } catch (err) {
        console.error("Reject failed:", err);
        toast.error("Failed to remove samples. Please try again.");
        
      }
      finally{
        setShowMainRejectConfirm(false);
        setRemoveReason("");
        fetchData();
        setSelectedSampleIds(new Set());
      }
    };
  
  const handleRowExpandToggle = (groupId) => {
    setExpandedId((prev) => {
      if (prev.includes(groupId)) {
        return prev.filter((id) => id !== groupId);
      } else {
        return [...prev, groupId];
      }
    });
  };

  const fetchData = async (searchText, page, pageSize, options = {}) => {
    const shouldUseDateFilters =
      options.useDateFilters !== undefined
        ? options.useDateFilters
        : useAdvancedDates;

    const payload = {
      pageNumber: page,
      pageSize: pageSize,
      filterText: "",
      fromDate:
        shouldUseDateFilters && fromDate
          ? new Date(fromDate).toISOString()
          : null,
      toDate:
        shouldUseDateFilters && toDate
          ? new Date(toDate).toISOString()
          : null,
      status: selectedStatuses.length > 0 ? selectedStatuses.join(",") : "",
      groupId: advancedSearch.groupId ? Number(advancedSearch.groupId) : 0,
      companyName: advancedSearch.companyName || "",
      userName: advancedSearch.userName || "",
      // salesRep: advancedSearch.salesRep ? Number(advancedSearch.salesRep) : 0,
      customerSampleId: advancedSearch.customerSampleId || "",
      lotNumber: advancedSearch.lotNumber || "",
      sampleId: advancedSearch.sampleId ? Number(advancedSearch.sampleId) : 0,
      productType:
        advancedSearch.productType && advancedSearch.productType !== "All"
          ? Number(advancedSearch.productType)
          : 0,
      speciesType:
        advancedSearch.speciesType && advancedSearch.speciesType !== "All"
          ? Number(advancedSearch.speciesType)
          : 0,
    };
    // const initialpayload = {
    //   pageNumber: currentPage,
    //   pageSize: rowsPerPage,
    //   filterText: searchTerm,
    //   fromDate: oneMonthAgo,
    //   toDate: today,
    //   status: selectedStatuses.length > 0 ? selectedStatuses.join(",") : "",
    //   groupId: 0,
    //   companyName: "",
    //   userName: "",
    //   // salesRep: 0,
    //   customerSampleId: "",
    //   lotNumber: "",
    //   sampleId: 0,
    //   productType: 0,
    //   speciesType: 0,
    //   // state: "",
    // };
    setLoading(true);
    try {
      const res = await getRequestedListData(payload);
      const { totalRecords, pageNumber, pageSize, totalPages } = res;
      setPaginationData({ totalRecords, pageNumber, pageSize, totalPages });
      setRequestedListData(Array.isArray(res.results) ? res.results : []);
    } catch (error) {
      setRequestedListData([]);
      console.error("Error fetching RequestedList data:", error);
    } finally {
      setLoading(false);
    }
  };

  const toggleExpand = (groupId) => {
    setExpandedId((prev) => (prev === groupId ? null : groupId));
  };

  // Selection helpers
  const isAllSelectedOnPage =
    requestedListData.length > 0 &&
    requestedListData.every((r) => selectedRowIds.has(r.groupID));

  const toggleRowSelection = useCallback((groupID) => {
    setSelectedRowIds((prev) => {
      const copy = new Set(prev);
      if (copy.has(groupID)) copy.delete(groupID);
      else copy.add(groupID);
      return copy;
    });
  }, []);

  const toggleSelectAllOnPage = () => {
    setSelectedRowIds((prev) => {
      const copy = new Set(prev);
      if (!isAllSelectedOnPage) {
        requestedListData.forEach((r) => copy.add(r.groupID));
      } else {
        requestedListData.forEach((r) => copy.delete(r.groupID));
      }
      return copy;
    });
  };

  // Table columns
  const columns = useMemo(
    () => [
      {
        header: (
          <Form.Check
            type="checkbox"
            checked={isAllSelectedOnPage}
            onChange={toggleSelectAllOnPage}
            aria-label="Select all"
          />
        ),
        accessor: "checkbox",
        disableSort: true,
        cell: (row) => (
          <Form.Check
            type="checkbox"
            checked={selectedRowIds.has(row.groupID)}
            onChange={() => toggleRowSelection(row.groupID)}
            aria-label={`Select ${row.groupID}`}
          />
        ),
      },
      { header: "Company", accessor: "companyName" },
      { header: "Location", accessor: "locationName" },
      { header: "Group ID", accessor: "groupID" },
      { header: "User Name", accessor: "userName" },
      {
        header: "Action",
        accessor: "action",
        disableSort: true,
        cell: (row) => (
          <Button
            size="sm"
            variant="edit-disabled"
            onClick={() => handleEditGroupClick(row)}
          >
            Edit
          </Button>
        ),
      },
      {
        header: (
          <Button onClick={toggleExpandAll}>
            {expandAll ? "Collapse All" : "Expand All"}
          </Button>
        ),
        accessor: "expand",
        disableSort: true,
        cell: (row) => (
          <div className="d-flex justify-content-center">
            <div
              onClick={() => {
                handleRowExpandToggle(row.groupID);
              }}
              style={{
                cursor: "pointer",
              }}
              aria-label={
                expandedId.includes(row.groupID)
                  ? "Collapse details"
                  : "Expand details"
              }
            >
              <FaChevronDown
                size={14}
                style={{
                  transition: "transform .2s",
                  transform: expandedId.includes(row.groupID)
                    ? "rotate(180deg)"
                    : "none",
                }}
              />
            </div>
          </div>
        ),
      },
    ],
    [
      isAllSelectedOnPage,
      selectedRowIds,
      toggleRowSelection,
      toggleSelectAllOnPage,
    ]
  );

  // Expanded panel
  const renderExpandedPanel = (data) => {
    const subRowData = data.requestedSamples || [];
    const allSamplesSelected =
      subRowData.length > 0 &&
      subRowData.every((r) => selectedSampleIds.has(r.sampleId));
    const handleSelectAllSamples = () => {
      setSelectedSampleIds((prev) => {
        const copy = new Set(prev);
        if (!allSamplesSelected) {
          subRowData.forEach((r) => copy.add(r.sampleId));
        } else {
          subRowData.forEach((r) => copy.delete(r.sampleId));
        }
        return copy;
      });
    };
    const expandedColumns = [
      {
        header: (
          <Form.Check
            type="checkbox"
            checked={allSamplesSelected}
            onChange={handleSelectAllSamples}
            aria-label="Select all samples"
          />
        ),
        accessor: "checkbox",
        disableSort: true,
        cell: (row) => (
          <Form.Check
            type="checkbox"
            checked={selectedSampleIds.has(row.sampleId)}
            onChange={() => {
              setSelectedSampleIds((prev) => {
                const copy = new Set(prev);
                if (copy.has(row.sampleId)) copy.delete(row.sampleId);
                else copy.add(row.sampleId);
                return copy;
              });
            }}
            aria-label={`Select ${row.sampleId}`}
          />
        ),
      },
      { header: "Sample ID", accessor: "sampleId" },
      {
        header: "Request Date",
        accessor: "requestedDate",
        cell: (row) => formatDate(row.requestedDate) || "-",
      },
      {
        header: "Received Date",
        accessor: "receivedDate",
        cell: (row) => formatDate(row.receivedDate) || "-",
      },
      { header: "Barcode No.", accessor: "barCodeNO" },
      { header: "Species", accessor: "speciesName" },
      { header: "Product", accessor: "productTypeName" },
      // { header: "Lot No.", accessor: "lotNumber" },
      { header: "Customer Sample ID", accessor: "customerSampleId" },
      { header: "Status", accessor: "lastStatus" },
      {
        header: "Action",
        accessor: "action",
        disableSort: true,
        cell: (row) => (
          <Button
            size="sm"
            variant="edit-active"
            onClick={() => {
              handleSampleEdit(row);
            }}
          >
            Edit
          </Button>
        ),
      },
    ];
    return (
      <tr className="expanded-row" key={`${data.groupID}-expanded`}>
        <td colSpan={8} style={{ padding: 0, background: "#f5f8fb" }}>
          <div style={{ margin: "8px 16px" }}>
            <SimpleTable
              columns={expandedColumns}
              data={subRowData}
              showPagination={false}
              customRowRender={undefined}
            />
          </div>
        </td>
      </tr>
    );
  };

  const handlePrint = async () => {
    const selectedGroups = Array.from(selectedRowIds);
    const selectedSamples = Array.from(selectedSampleIds);

    if (!selectedGroups.length && !selectedSamples.length) {
      toast.error("Please select at least one Group or Sample to print");
      return;
    }

    try {
      await getPrintSampleData(selectedGroups, selectedSamples);
    } catch (err) {
      console.error("Print failed", err);
      toast.error("Failed to print. Please try again.");
    }
  };
  const handleAdvanceSearch = () => {
    setUseAdvancedDates(true);
    fetchData("", 1, 25, { useDateFilters: true });
    setShowAdvancedSearch(false);
  };
  const handleSampleEdit = async (row) => {
    setSample(row.sampleId);
    setShowEditModal(true);
  };

  const handleEditDataChange = (updatedData) => {
    setEditRowData((prev) => ({
      ...prev,
      ...updatedData,
    }));
  };
  const handleSampleUpdate = async () => {
    try {
      const {
        sampleId,
        result,
        newComments,
        productTypeId,
        locationId,
        unitId,
        speciesId,
        companyId,
        lotNumber,
        customerSampleId,
        barcode,
        expectedLevel,
        cfrMaxLevel,
        cfrMinLevel,
        loqValue,
        productTypeName,
        productTradeNameId,
        productTradeName,
        feedTypeId,
        feedTypeName,
        speciesName,
        manufactureDate,
      } = editRowData;
      if (!newComments) {
        toast.error("New Comments are required.");
        return;
      }
      const response = await updateSampleEditData({
        sampleId,
        assayResult: result,
        remarks: newComments,
        productTypeId: productTypeId,
        unitId,
        speciesId,
        locationId,
        companyId,
        cfrMaxLevel,
        cfrMinLevel,
        loqValue,
        lotNumber: lotNumber,
        customerSampleId: customerSampleId,
        barcodeNumber: barcode,
        expectedLevel: expectedLevel,
        productTypeName,
        productTradeNameId,
        productTradeName,
        feedTypeId,
        feedTypeName,
        speciesName,
        manufactureDate: manufactureDate || null,
      });
      toast.success("Sample updated successfully.");
      setShowEditModal(false);
      setEditRowData(null);
      fetchData();
      return;
    } catch (error) {
      toast.error("Failed to update sample.");
    }
    setShowEditModal(false);
    setEditRowData(null);
  };
  const handleSearch = () => {
    setUseAdvancedDates(false);
    fetchData("", 1, 25, { useDateFilters: false });
  };
  // Convert string dates to Date objects for DateRangePicker
  const fromDateObj = fromDate ? new Date(fromDate) : null;
  const toDateObj = toDate ? new Date(toDate) : null;

  // Multi-select status dropdown with checkboxes
  const handleStatusToggle = (status) => {
    setSelectedStatuses((prev) =>
      prev.includes(status)
        ? prev.filter((s) => s !== status)
        : [...prev, status]
    );
  };

  const handleSelectAllStatuses = () => {
    if (selectedStatuses.length === statusOptions.length) {
      setSelectedStatuses([]);
    } else {
      setSelectedStatuses([...statusOptions]);
    }
  };

  const hasNonRejectedSelectedSamples = useMemo(
    () => getNonRejectedSelectedSampleIds().length > 0,
    [getNonRejectedSelectedSampleIds]
  );

  return (
    <div>
      <SecondTab tabConfig={TabConfig} />
      <div className="p-3 typography">
        <PageDescriptionBar items={[
          { type: "icon",  icon: "✏️", text: "Edit – Modify sample details for the selected request" },
          { type: "icon",  icon: "☑️", text: "Select – Check rows to perform bulk group operations" },
          { type: "separator" },
          { type: "icon",  icon: "🔍", text: "Status Filter – Filter the list by current sample status" },
          { type: "icon",  icon: "📅", text: "Date Range – Narrow results to a specific submission period" },
        ]} />
        {/* Filters row */}
        <div
          className="d-flex shadow-lg flex-wrap gap-3 mb-2 align-items-center p-3"
          style={{ background: "#fff", borderRadius: "5px" }}
        >
          {/* Custom Date Picker */}
          {/* <DateRangePicker
            fromDate={fromDateObj}
            toDate={toDateObj}
            onFromDateChange={setFromDate}
            onToDateChange={setToDate}
            fromLabel="From"
            toLabel="To"
            className="me-3"
          /> */}

          {/* Select Status */}
          <div className="d-flex align-items-center gap-1">
            <label style={{ fontSize: 14 }}>Select Status</label>
            <Dropdown>
              <Dropdown.Toggle
                variant="outline-secondary"
                style={{ width: 160, height: 44, borderRadius: 5 }}
                size="sm"
                id="dropdown-status-multiselect"
              >
                {selectedStatuses.length === 0
                  ? "All"
                  : `${selectedStatuses.length} selected`}
              </Dropdown.Toggle>
              <Dropdown.Menu style={{ minWidth: 180 }}>
                <Dropdown.Item
                  as="div"
                  style={{ padding: "4px 12px", fontWeight: 600 }}
                  onClick={(e) => e.stopPropagation()}
                >
                  <Form.Check
                    type="checkbox"
                    id="status-checkbox-all"
                    label="Select All"
                    checked={selectedStatuses.length === statusOptions.length}
                    onChange={handleSelectAllStatuses}
                  />
                </Dropdown.Item>
                {statusOptions.map((status) => (
                  <Dropdown.Item
                    key={status}
                    as="div"
                    style={{ padding: "4px 12px" }}
                    onClick={(e) => e.stopPropagation()}
                  >
                    <Form.Check
                      type="checkbox"
                      id={`status-checkbox-${status}`}
                      label={status}
                      checked={selectedStatuses.includes(status)}
                      onChange={() => handleStatusToggle(status)}
                    />
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
          </div>

          {/* Search button */}
          <div className="d-flex align-items-center">
            <Button variant="outlined" onClick={handleSearch}>
              Search
            </Button>
          </div>
          <div
            className="line-separator"
            style={{
              width: "1px",
              height: "46px",
              backgroundColor: "rgba(0, 0, 0, 0.3)",
              margin: "0 10px",
            }}
          />

          {/* Advance Search */}
          <div className="d-flex align-items-center">
            <Button
              variant="outlined"
              onClick={() => setShowAdvancedSearch(true)}
            >
              Advance Search
            </Button>
          </div>

          {isLabAdmin && (
            <div className="d-flex align-items-center gap-2">
              <Button
                variant={hasNonRejectedSelectedSamples ? "outlined" : "disabled"}
                size="md"
                disabled={!hasNonRejectedSelectedSamples}
                onClick={() => handleRemoveSamples()}
              >
                Remove
              </Button>
            </div>
          )}

          {/* Print right-aligned */}
          <div className="ms-auto">
            <Button
              variant={
                selectedRowIds.size > 0 || selectedSampleIds.size > 0
                  ? "outlined"
                  : "disabled"
              }
              size="md"
              disabled={
                selectedRowIds.size === 0 && selectedSampleIds.size === 0
              }
              onClick={handlePrint}
            >
              Print
            </Button>
          </div>
        </div>
        <Card>
          <Card.Body className="p-0">
            {/* Table */}
            {loading ? (
              <div
                className="d-flex justify-content-center align-items-center"
                style={{ minHeight: 300 }}
              >
                <Spinner animation="border" /> Loading...
              </div>
            ) : (
              <SimpleTable
                columns={columns}
                data={requestedListData}
                customRowRender={(row, idx) => (
                  <React.Fragment key={`${row.groupID}_${idx}`}>
                    <tr>
                      <td>
                        <Form.Check
                          type="checkbox"
                          checked={selectedRowIds.has(row.groupID)}
                          onChange={() => toggleRowSelection(row.groupID)}
                        />
                      </td>
                      <td>{row.companyName}</td>
                      <td>{row.locationName}</td>
                      <td>{row.groupID}</td>
                      <td>{row.userName}</td>
                      <td>
                        <Button
                          size="sm"
                          variant="edit-disabled"
                          onClick={() => {
                            setEditGroupRow(row);
                            setShowEditGroupModal(true);
                          }}
                        >
                          Edit
                        </Button>
                      </td>
                      <td>
                        <div
                          className="d-flex justify-content-center"
                          onClick={() => handleRowExpandToggle(row.groupID)}
                          style={{
                            cursor: "pointer",
                            display: "flex",
                            marginLeft: 20,
                          }}
                          aria-label={
                            expandedId.includes(row.groupID)
                              ? "Collapse details"
                              : "Expand details"
                          }
                        >
                          <FaChevronDown
                            size={14}
                            style={{
                              transition: "transform .2s",
                              transform: expandedId.includes(row.groupID)
                                ? "rotate(180deg)"
                                : "none",
                            }}
                          />
                        </div>
                      </td>
                    </tr>
                    {expandedId.includes(row.groupID) &&
                      renderExpandedPanel(row)}
                  </React.Fragment>
                )}
                showPagination
                paginationData={paginationData}
                fetchData={fetchData}
              />
            )}
          </Card.Body>
        </Card>
      </div>

      {/* Advanced Search Modal */}
      <ReusableModal
        show={showAdvancedSearch}
        onHide={() => setShowAdvancedSearch(false)}
        title="Advanced Search"
        size="lg"
        buttons={[
          {
            text: "Cancel",
            variant: "outlined",
            onClick: () => setShowAdvancedSearch(false),
          },
          {
            text: "Search",
            variant: "active",
            onClick: () => handleAdvanceSearch(),
          },
        ]}
      >
        <Form>
          <div className="mb-3">
            <DateRangePicker
              fromDate={fromDateObj}
              toDate={toDateObj}
              onFromDateChange={setFromDate}
              onToDateChange={setToDate}
              fromLabel="From"
              toLabel="To"
              className="me-3"
            />
          </div>
          <div className="row g-3">
            <div className="col-md-4">
              <Form.Label>Group ID</Form.Label>
              <Form.Control
                name="groupId"
                placeholder="Enter Group ID"
                value={advancedSearch.groupId}
                onChange={handleAdvancedInputChange}
              />
            </div>
            <div className="col-md-4">
              <Form.Label>Company Name</Form.Label>
              <Form.Control
                name="companyName"
                placeholder="Enter Company Name"
                value={advancedSearch.companyName}
                onChange={handleAdvancedInputChange}
              />
            </div>
            <div className="col-md-4">
              <Form.Label>User Name</Form.Label>
              <Form.Control
                name="userName"
                placeholder="Enter User Name"
                value={advancedSearch.userName}
                onChange={handleAdvancedInputChange}
              />
            </div>
            <div className="col-md-4">
              <Form.Label>Sales Rep</Form.Label>
              <Form.Control
                name="salesRep"
                placeholder="Enter Sales Rep"
                value={advancedSearch.salesRep}
                onChange={handleAdvancedInputChange}
              />
            </div>
            <div className="col-md-4">
              <Form.Label>Customer Sample ID</Form.Label>
              <Form.Control
                name="customerSampleId"
                placeholder="Enter Customer Sample ID"
                value={advancedSearch.customerSampleId}
                onChange={handleAdvancedInputChange}
              />
            </div>
            <div className="col-md-4">
              <Form.Label>Lot Number</Form.Label>
              <Form.Control
                name="lotNumber"
                placeholder="Enter Lot Number"
                value={advancedSearch.lotNumber}
                onChange={handleAdvancedInputChange}
              />
            </div>
            <div className="col-md-4">
              <Form.Label>Sample ID</Form.Label>
              <Form.Control
                name="sampleId"
                placeholder="Enter Sample ID"
                value={advancedSearch.sampleId}
                onChange={handleAdvancedInputChange}
              />
            </div>
            <div className="col-md-4">
              <Form.Label>Product</Form.Label>
              <Form.Select
                name="productType"
                value={advancedSearch.productType}
                onChange={handleAdvancedInputChange}
              >
                {productTypeOptions.map((type) => (
                  <option
                    key={type.value}
                    value={type.value}
                    label={type.label}
                  >
                    {type.label}
                  </option>
                ))}
              </Form.Select>
            </div>
            <div className="col-md-4">
              <Form.Label>Species</Form.Label>
              <Form.Select
                name="speciesType"
                value={advancedSearch.speciesType}
                onChange={handleAdvancedInputChange}
              >
                {speciesOptions.map((species) => (
                  <option
                    key={species.value}
                    value={species.value}
                    label={species.label}
                  >
                    {species.label}
                  </option>
                ))}
              </Form.Select>
            </div>
            {/* <div className="col-md-4"> */}
            {/* <Form.Label>State</Form.Label>
              <Form.Select
                name="state"
                value={advancedSearch.state}
                onChange={handleAdvancedInputChange}
              >
                {stateOptions.map((state) => (
                  <option key={state} value={state}>
                    {state}
                  </option>
                ))}
              </Form.Select>
            </div> */}
          </div>
        </Form>
      </ReusableModal>

      {/* Sample EditPage Modal - commented out (duplicate of SampleModalWrapper)
      <ReusableModal
        show={showEditModal}
        onHide={() => {
          setShowEditModal(false);
          setEditRowData(null);
        }}
        title={`Product : ${editRowData?.product || ""}`}
        size="xl"
        buttons={[
          {
            text: "Cancel",
            variant: "outlined",
            onClick: () => {
              setShowEditModal(false);
              setEditRowData(null);
            },
          },
          {
            text: "Update",
            variant: "active",
            onClick: () => {
              handleSampleUpdate();
            },
          },
        ]}
      >
        {/* Render EditPage component and pass the selected row data as props *}
      </ReusableModal>
      */}
      <SampleModalWrapper
        sampleID={sample}
        showModal={showEditModal}
        setShowModal={setShowEditModal}
        setSampleID={setSample}
        onUpdateSuccess={() => fetchData("", 1, 25, { useDateFilters: false })}
      />

      {/* Edit Group Modal */}
      <ReusableModal
        show={showEditGroupModal}
        onHide={() => setShowEditGroupModal(false)}
        title="Edit Group"
        size="lg"
        buttons={[
          {
            text: "Cancel",
            variant: "outlined",
            onClick: () => setShowEditGroupModal(false),
          },
          {
            text: "Update",
            variant: "active",
            onClick: async () => {
              // If no change made, use old location id
              const locationIdToUpdate = newLocationId
                ? Number(newLocationId)
                : editGroupRow.locationId;
              await updateLocation({
                companyId: editGroupRow.companyID,
                oldLocationId: editGroupRow.locationId,
                newLocationId: locationIdToUpdate,
                groupId: editGroupRow.groupID,
              });
              setShowEditGroupModal(false);
              fetchData();
            },
          },
        ]}
      >
        {editGroupRow && (
          <table className="table">
            <thead>
              <tr>
                <th>Company</th>
                <th>Current Location</th>
                <th>Group ID</th>
                <th>New Location</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{editGroupRow.companyName}</td>
                <td>
                  {locationOptions.find(
                    (loc) => loc.id === editGroupRow.locationId
                  )?.name || editGroupRow.locationName}
                </td>
                <td>{editGroupRow.groupID}</td>
                <td>
                  <select
                    value={newLocationId || editGroupRow.locationId}
                    onChange={(e) => setNewLocationId(e.target.value)}
                    className="form-select"
                  >
                    <option value="">Select Location</option>
                    {locationOptions.map((loc) => (
                      <option key={loc.locationId} value={loc.locationId}>
                        {loc.name}
                      </option>
                    ))}
                  </select>
                </td>
              </tr>
            </tbody>
          </table>
        )}
      </ReusableModal>
      
      <ReusableModal
            show={showMainRejectConfirm}
            onHide={() => {
              setShowMainRejectConfirm(false);
              setRemoveReason("");
            }}
            title="Confirm Remove"
            buttons={[
              {
                text: "Cancel",
                variant: "outlined",
                onClick: () => {
                  setShowMainRejectConfirm(false);
                  setRemoveReason("");
                },
              },
              {
                text: "OK, Remove",
                variant: "active",
                onClick: () => handleConfirmReject(),
              },
            ]}
          >
            <p>Remove {selectedSampleIds.size} selected sample(s)?</p>
            <Form.Group className="mt-3" controlId="removeReason">
              <Form.Label>Reason for Remove</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                value={removeReason}
                onChange={(e) => setRemoveReason(e.target.value)}
                placeholder="Enter reason"
              />
            </Form.Group>
          </ReusableModal>
      
      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
};

export default RequestedList;
